export default "__VITE_ASSET__53336871__"